export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mb-8">
          有问题、建议或想投稿推荐好剧？欢迎随时联系我们
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
            <span className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </span>
            <h3 className="font-heading text-sm text-foreground-900 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-400">business@nightcat.tv</p>
          </div>
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
            <span className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-chat-smile-2-line text-xl text-accent-600"></i>
            </span>
            <h3 className="font-heading text-sm text-foreground-900 mb-1">剧集投稿</h3>
            <p className="text-xs text-foreground-400">submit@nightcat.tv</p>
          </div>
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
            <span className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-question-answer-line text-xl text-secondary-600"></i>
            </span>
            <h3 className="font-heading text-sm text-foreground-900 mb-1">客服支持</h3>
            <p className="text-xs text-foreground-400">support@nightcat.tv</p>
          </div>
        </div>
        <p className="text-xs text-foreground-400 mt-6">工作时间：周一至周日 10:00 - 凌晨2:00（夜猫子专属时段）</p>
      </div>
    </section>
  );
}